import React from "react";

export default function ProfileIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <circle cx="5" cy="4" r="2.5" stroke="currentColor" strokeWidth="1.1" />
      <path
        d="M1 11c0-2.2 1.8-4 4-4s4 1.8 4 4"
        stroke="currentColor"
        strokeWidth="1.1"
        fill="none"
      />
    </svg>
  );
}
